import { HomeExamPage } from './HomeExamPage';
export default HomeExamPage;
